import { combineReducers } from 'redux';

const crazyEggFeatureFlag = (state = false) => {
    const nextState = state;

    return nextState;
};

const cappedFeeExperimentFeatureFlag = (state = false) => state;

const enablePricingCalculator = (state = false) => {
    const nextState = state;

    return nextState;
};

const launchPackageEssentialV2 = (state = false) => {
    const nextState = state;

    return nextState;
};

const isPackageChangeDowngradeEnabled = (state = false) => {
    const nextState = state;

    return nextState;
};

export default combineReducers({
    cappedFeeExperimentFeatureFlag,
    crazyEggFeatureFlag,
    enablePricingCalculator,
    launchPackageEssentialV2,
    isPackageChangeDowngradeEnabled,
});
